import {observer} from 'mobx-react';

const LocationIcon = observer(({clockEvent, uiState}) => {
  const {myTimesheet} = uiState;

  if (myTimesheet || !clockEvent?.location) return null;

  return (
    <i
      className={`material-icons h3 clickable ml1 ${clockEvent.withinGeofence ? 'jumbo' : 'sun'}`}
      onClick={() => uiState.openClockInLocationModal(clockEvent)}
    >
      {clockEvent.withinGeofence ? 'location_on' : 'fmd_bad'}
    </i>
  );
});

export default LocationIcon;
